import { useTranslation } from 'react-i18next';

import Header from '../../components/layout/Header';

import Scene from '../../components/ui/Earth';

import '../../styles/Impact.css';

import { Container } from 'react-bootstrap';

import { Link } from 'react-router-dom';

import team3 from '../../assets/img/team3.webp';

import team4 from '../../assets/img/team4.webp';
import { trackMatomoEvent } from '../../utils/matomo';

const ODS_ITEMS = [
  { id: 'ods3', image: '/ods/ods3.webp' },

  { id: 'ods8', image: '/ods/ods8.webp' },

  { id: 'ods9', image: '/ods/ods9.webp' },

  { id: 'ods12', image: '/ods/ods12.webp' },

  { id: 'ods13', image: '/ods/ods13.webp' },
];

const STEPS = [
  {
    id: 'step1',

    titleKey: 'impact.steps.step1.title',

    descKey: 'impact.steps.step1.desc',
  },

  {
    id: 'step2',

    titleKey: 'impact.steps.step2.title',

    descKey: 'impact.steps.step2.desc',
  },

  {
    id: 'step3',

    titleKey: 'impact.steps.step3.title',

    descKey: 'impact.steps.step3.desc',
  },

  {
    id: 'step4',

    titleKey: 'impact.steps.step4.title',

    descKey: 'impact.steps.step4.desc',
  },
];

const PROJECTS = [
  { id: 'p1', avatars: [team3] },

  { id: 'p2', avatars: [team3, team4] },
] as const;

export default function ImpactPage() {
  const { t } = useTranslation();

  return (
    <>
      <Header />

      <Container>
        <main className="impact-shell dark">
          <section className="impact-card">
            <header className="impact-hero2">
              <div className="impact-hero2-left">
                <h1 className="impact-hero2-title">
                  {t('impact.hero.title_line1')}

                  <br />

                  {t('impact.hero.title_line2')}
                </h1>

                <p className="impact-hero2-desc">
                  {t('impact.hero.description')}
                </p>

                <div className="impact-hero2-actions">
                  <Link
                    to="/projects"
                    className="impact-btn impact-btn-primary"
                    onClick={() =>
                      trackMatomoEvent('CTA', 'click', 'Impact projects')
                    }
                  >
                    {t('impact.hero.cta_primary')}
                  </Link>

                  <Link
                    to="/services"
                    className="impact-btn impact-btn-ghost"
                    onClick={() =>
                      trackMatomoEvent('CTA', 'click', 'Impact services')
                    }
                  >
                    {t('impact.hero.cta_secondary')}
                  </Link>
                </div>
              </div>

              <div className="impact-hero2-right" aria-hidden>
                <div className="impact-media-frame">
                  <div className="impact-planet-cut">
                    <div className="impact-planet-shift">
                      <Scene />
                    </div>
                  </div>

                  <div className="impact-media-glow" />
                </div>
              </div>
            </header>
          </section>

          <section className="impact-section">
            <div className="impact-section-head">
              <h2 className="impact-h2">{t('impact.ods.title')}</h2>

              <p className="impact-p">{t('impact.ods.subtitle')}</p>
            </div>

            <div className="impact-ods-grid2">
              {ODS_ITEMS.map((item) => (
                <article key={item.id} className="impact-ods-card">
                  <div className="impact-ods-thumb">
                    <img
                      src={item.image}
                      alt={t(`impact.ods.items.${item.id}.title`)}
                      loading="lazy"
                      fetchPriority="low"
                      decoding="async"
                    />
                  </div>

                  <div className="impact-ods-body">
                    <h3 className="impact-ods-title">
                      {t(`impact.ods.items.${item.id}.title`)}
                    </h3>

                    <p className="impact-ods-desc">
                      {t(`impact.ods.items.${item.id}.desc`)}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </section>

          <section className="impact-section impact-how">
            <div className="impact-section-head">
              <h2 className="impact-h2">{t('impact.how.title')}</h2>

              <p className="impact-p">{t('impact.how.subtitle')}</p>
            </div>

            <div className="impact-how-grid">
              <div className="impact-how-media" aria-hidden>
                <div className="impact-how-media-card">
                  <div className="impact-how-media-badge">
                    {t('impact.how.badge')}
                  </div>
                </div>
              </div>

              <div className="impact-steps">
                {STEPS.map((step, idx) => (
                  <article key={step.id} className="impact-step">
                    <div className="impact-step-dot">{idx + 1}</div>

                    <div className="impact-step-text">
                      <h3 className="impact-step-title">{t(step.titleKey)}</h3>

                      <p className="impact-step-desc">{t(step.descKey)}</p>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </section>

          <section className="impact-section impact-team">
            <div className="impact-section-head">
              <h2 className="impact-h2">{t('impact.teamImpact.title')}</h2>

              <p className="impact-p">{t('impact.teamImpact.subtitle')}</p>
            </div>

            <div className="impact-team-grid">
              {PROJECTS.map((project) => (
                <article key={project.id} className="impact-post">
                  <header className="impact-post-head">
                    <div
                      className={`impact-post-avatar ${project.avatars.length > 1 ? 'is-split' : 'is-single'}`}
                      aria-hidden
                    >
                      {project.avatars.map((src, index) => (
                        <img
                          key={`${project.id}-avatar-${index}`}
                          src={src}
                          alt=""
                          className="impact-post-avatar-img"
                          loading="lazy"
                          fetchPriority="low"
                          decoding="async"
                        />
                      ))}
                    </div>

                    <div className="impact-post-meta">
                      <div className="impact-post-author">
                        {t(`impact.projects.items.${project.id}.author`)}
                      </div>

                      <div className="impact-post-role">
                        {t(`impact.projects.items.${project.id}.role`)}
                      </div>
                    </div>
                  </header>

                  <h3 className="impact-post-title">
                    {t(`impact.projects.items.${project.id}.title`)}
                  </h3>

                  <p className="impact-post-summary">
                    {t(`impact.projects.items.${project.id}.summary`)}
                  </p>

                  <div className="impact-post-impact">
                    <span className="impact-post-impactLabel">
                      {t('impact.projects.impactLabel')}
                    </span>

                    <p className="impact-post-impactText">
                      {t(`impact.projects.items.${project.id}.impact`)}
                    </p>
                  </div>

                  <footer className="impact-post-footer">
                    <span className="impact-chip">
                      {t(`impact.projects.items.${project.id}.ods`)}
                    </span>

                    <span className="impact-chip impact-chip-soft">
                      {t(`impact.projects.items.${project.id}.tags`)}
                    </span>
                  </footer>
                </article>
              ))}
            </div>
          </section>

          <section className="impact-cta2">
            <div className="impact-cta2-inner">
              <div>
                <h3 className="impact-cta2-title">{t('impact.cta.title')}</h3>

                <p className="impact-cta2-desc">{t('impact.cta.desc')}</p>
              </div>

              <Link
                to="/contact"
                className="impact-btn impact-btn-primary"
                onClick={() =>
                  trackMatomoEvent('CTA', 'click', 'Impact contact')
                }
              >
                {t('impact.cta.button')}
              </Link>
            </div>
          </section>
        </main>
      </Container>
    </>
  );
}
